import { z } from "zod";

export const schema = z.object({
	// number: z.string().regex(/^\d{19}$/, "Cartão inválido"),
	number: z.string().min(13, "Número do cartão é obrigatório"),
	holderName: z.string().min(1, "Nome do titular é obrigatório"),
	expirationDate: z.string().regex(/^(0[1-9]|1[0-2])\/?([0-9]{4}|[0-9]{2})$/, "Data de expiração inválida"),
	ccv: z.string().regex(/^\d{3,4}$/, "Inválido CVV"),
});

export const schemaDefaultValues = {
	number: "",
	holderName: "",
	expirationDate: "",
	ccv: "",
};
